import { jsx as _jsx } from "react/jsx-runtime";
import { usePoliciesData } from '../../components/PoliciesContext';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
const authenticatedRoute = (Component, options) => {
    const opts = options || { pathAfterFailure: '/' };
    const AuthenticatedRoute = (props) => {
        const [loading, setLoading] = useState(true);
        const navigate = useNavigate();
        const getPolicies = usePoliciesData();
        useEffect(() => {
            const authenticateAndRedirect = async () => {
                const isLoggedIn = Cookies.get('access_token');
                if (isLoggedIn) {
                    // Ensure policies are loaded (will use cache if available)
                    await getPolicies();
                    setLoading(false);
                }
                else {
                    navigate(opts.pathAfterFailure);
                }
            };
            authenticateAndRedirect();
        }, []);
        if (loading) {
            return _jsx("div", {});
        }
        return _jsx(Component, { ...props });
    };
    return AuthenticatedRoute;
};
export default authenticatedRoute;
